module.exports = __webpack_public_path__ + "static/media/snappy.95ec86ea.svg";